module.exports = __webpack_public_path__ + "img/csv.68e9923.png";